import '../../common/common.js';
import '../../common/partials/example-partial/client';
import TaxononyHeader from './components/taxonomyHeader/';
import { DOM } from '../../common/browser';
import PageController from './pageController';
new TaxononyHeader();

DOM.ready(() => {
    //Initialize page components
    PageController.init();
});


// WEBPACK FOOTER //
// /src/pages/main/client.js